export const PASSWORD_REGEX = /^(?=(?:.*\d))(?=(?:.*[a-z]))(?=(?:.*[A-Z]))(?=(?:.*[!@#$%&*()]))[A-Za-z\d!@#$%&*()]{8,}$/
